export default "__VITE_ASSET__CZXBu3Is__"